"use strict";
/**
 * Ex-Online socket namespaces
 * (i.e. Constants for io.of(namespace))
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NS_QUEUE = exports.NS_PROJECT = void 0;
/**
 * Socket created in this namespace handles all tag-browser socket events
 */
const TAG_BROWSER_PREFIX = "/tag-browser";
/**
 * Socket created in this namespace handles all project related events
 */
exports.NS_PROJECT = `${TAG_BROWSER_PREFIX}/project`;
/**
 * Socket created in this namespace handles all bull queue related events
 */
exports.NS_QUEUE = `${TAG_BROWSER_PREFIX}/bull-queue`;
//# sourceMappingURL=namespaces.js.map